import { defineStore } from "pinia";

export const useSnackbarStore = defineStore("snackbar", {
  state: () => ({
    snackbars: [],
    queue: [],
    isProcessing: false,
  }),

  actions: {
    show(message, options = {}) {
      const snackbar = {
        id: crypto.randomUUID(),
        isVisible: true,
        text: message,
        color: options.color || "neutral-40",
        timeout: options.duration || 4000,
      };

      this.queue.push(snackbar);
      if (!this.isProcessing) {
        this.processQueue();
      }
    },

    success(message, duration = 4000) {
      this.show(message, { color: "neutral-40", duration });
    },

    error(message, duration = 4000) {
      this.show(message, { color: "error-40", duration });
    },

    processQueue() {
      if (this.queue.length === 0) {
        this.isProcessing = false;
        return;
      }

      this.isProcessing = true;
      const snackbarToAdd = this.queue.shift();
      this.snackbars.push(snackbarToAdd);

      setTimeout(() => {
        this.processQueue();
      }, 300);
    },

    remove(snackbarId) {
      const index = this.snackbars.findIndex((snackbar) => snackbar.id === snackbarId);
      if (index > -1) this.snackbars.splice(index, 1);
    },
  },
});